import { REALMS } from 'ciam-self-service-shared';

const PRODUCTS_PATH = 'id.manulife.ca/products';
const BROKER_TST_LOGIN = 'https://broker-ui-tst.apps.cac.preview.pcf.manulife.com/member/login';
const BROKER_TST_LOGIN_EN_CA = `${BROKER_TST_LOGIN}?ui_locales=en-CA`;
const BROKER_TST_LOGIN_FR_CA = `${BROKER_TST_LOGIN}?ui_locales=fr-CA`;
const MPPBROKER_UAT_LOGIN_EN_CA = 'https://mppbroker-uat.manulife.com/member/login?ui_locales=en-CA';
const MPPBROKER_UAT_LOGIN_FR_CA = 'https://mppbroker-uat.manulife.com/member/login?ui_locales=fr-CA';
const UAT_TRAVEL_AGENTS_EN_CA = 'https://uat.manulife-insurance.ca/agents';
const UAT_TRAVEL_AGENTS_FR_CA = 'https://uat.assurance-manuvie.ca/agents';

const ID_PATHS = {
  [REALMS.ADVISOR]: 'advisor/auth',
  [REALMS.CUSTOMER]: 'auth',
  [REALMS.SPONSOR]: 'sponsor/auth',
};

const idRedirect = (envPrefix, realm) => ({
  'en-CA': `https://${envPrefix}${PRODUCTS_PATH}/${ID_PATHS[realm]}?ui_locales=en-CA`,
  'fr-CA': `https://${envPrefix}${PRODUCTS_PATH}/${ID_PATHS[realm]}?ui_locales=fr-CA`,
});

const travelB2b = (envName) => ({
  'en-CA': `https://travelb2b-${envName}.apps.cac.preview.pcf.manulife.com/agents`,
  'fr-CA': `https://travelb2b-${envName}-fr.apps.cac.preview.pcf.manulife.com/agents`,
});

const brokerTstLocalized = { 'en-CA': BROKER_TST_LOGIN_EN_CA, 'fr-CA': BROKER_TST_LOGIN_FR_CA };
const mppbrokerUat = { 'en-CA': MPPBROKER_UAT_LOGIN_EN_CA, 'fr-CA': MPPBROKER_UAT_LOGIN_FR_CA };
const uatTravelAgents = { 'en-CA': UAT_TRAVEL_AGENTS_EN_CA, 'fr-CA': UAT_TRAVEL_AGENTS_FR_CA };

const buildEnv = (envPrefix, mci, travel) => ({
  [REALMS.ADVISOR]: idRedirect(envPrefix, REALMS.ADVISOR),
  [REALMS.CUSTOMER]: idRedirect(envPrefix, REALMS.CUSTOMER),
  [REALMS.MCI]: mci,
  [REALMS.SPONSOR]: idRedirect(envPrefix, REALMS.SPONSOR),
  [REALMS.TRAVEL]: travel,
});

const DEFAULT_REDIRECTS = {
  'qat.': buildEnv('qat.', brokerTstLocalized, travelB2b('qat')),
  'dev.': buildEnv('dev.', brokerTstLocalized, travelB2b('dev')),
  'sit.': buildEnv('sit.', { 'en-CA': BROKER_TST_LOGIN, 'fr-CA': BROKER_TST_LOGIN }, travelB2b('sit')),
  'uat.': buildEnv('uat.', mppbrokerUat, uatTravelAgents),
  'perf.': buildEnv('perf.', mppbrokerUat, uatTravelAgents),
  // when window.REACT_ENV is empty, environment is prod
  '': buildEnv(
    '',
    {
      'en-CA': 'https://mpphub.com/member/login?ui_locales=en-CA',
      'fr-CA': 'https://mpphub.com/member/login?ui_locales=fr-CA',
    },
    {
      'en-CA': 'https://www.manulife-insurance.ca/agents',
      'fr-CA': 'https://www.assurance-manuvie.ca/agents',
    },
  ),
};

const determineCallback = (env, locale, realm) => {
  const redirectUrl =
    (DEFAULT_REDIRECTS[env] && DEFAULT_REDIRECTS[env][realm] && DEFAULT_REDIRECTS[env][realm][locale]) ||
    'www.manulife.ca'; // defaulting to manulife.ca in case of unexpected values of env, realm or locale
  return redirectUrl;
};
export default determineCallback;
